import { useState } from 'react';
import type { DomainEntity } from '@web-config-app/core';
import {
  UseEntityGetOptions,
  useFindEntityInstanceById,
} from '@web-config-app/core-react';
import { useEntityDetailsProps } from '@web-config-app/entity-form';

export const useAddEntityById = (
  domainEntity: DomainEntity,
  options: UseEntityGetOptions | undefined,
) => {
  const [idValue, setIdValue] = useState<string>('');
  const { currentAuthoringEnvironment } = useEntityDetailsProps();
  const findById = useFindEntityInstanceById({
    domainEntity,
    instanceId: idValue,
    options,
    environment: currentAuthoringEnvironment,
  });

  return { ...findById, idValue, setIdValue };
};
